import { httpsCallable } from 'firebase/functions';
import { collection, query, where, limit, getDocs } from 'firebase/firestore';
import { db, functions } from './firebase';

interface PopulateResult {
  requestsCreated: number;
  attendeesSimulated: number;
}

interface ClearResult {
  requestsDeleted: number;
  votesDeleted: number;
}

export async function populatePracticeQueue(eventId: string): Promise<PopulateResult> {
  const callable = httpsCallable<{ eventId: string }, PopulateResult>(functions, 'populatePracticeQueue');
  const result = await callable({ eventId });
  return result.data;
}

export async function clearPracticeData(eventId: string): Promise<ClearResult> {
  const callable = httpsCallable<{ eventId: string }, ClearResult>(functions, 'clearPracticeData');
  const result = await callable({ eventId });
  return result.data;
}

export async function hasPracticeData(eventId: string): Promise<boolean> {
  const q = query(
    collection(db, 'requests'),
    where('eventId', '==', eventId),
    where('practiceMode', '==', true),
    limit(1)
  );
  const snap = await getDocs(q);
  return !snap.empty;
}
